<template>
    <div class="page page--light">
        <section class="row gradient-background">
            <div class="wrapper">
                <header class="row__header">
                    <back-button :isAbsolute="false"
                        :isBlack="true"
                    />

                    <h1>{{ $t('rewards.leaderboardTitle') }}</h1>
                </header>

                <div class="leaderboards">
                    <div class="leaderboards__header">
                        <h1>{{ $t('rewards.leaderboards.otherBoards') }}</h1>
                    </div>
                    <div class="leaderboards__body">
                        <template v-if="getOtherLeaderboards.length > 0">
                            <leaderboard-card v-for="(item, index) in getOtherLeaderboards"
                                :key="index"
                                class="cards"
                                :leaderboardData="item"
                                :participants="item.rankings.slice(0, 5)"
                                :searchable="false"
                                :showParticipationAmount="!isFreemiumLeaderboardsEnabled"
                                :isConditionsApplied="true"
                            />
                        </template>

                        <loading-spinner v-show="loading" />

                        <div v-if="!getOtherLeaderboards.length && !loading"
                            class="leaderboards__no-leaderboards"
                        >
                            {{ noLeaderboardsOrNoFilterText }}
                        </div>

                        <a v-if="page < getOtherLeaderboardsMetadata.last_page"
                            :class="['button', 'button--green', 'leaderboards__load-more', {'button--disabled': (loading)}]"
                            @click="loadMore"
                        >
                            {{ $t('rewards.leaderboards.loadMore') }}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';
import leaderboardCard from '@webapp/modules/rewards/components/leaderboards/leaderboard-card.vue';
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';

// Types
import {
    ServerConfigurationProps,
} from '@shared/types/config';

export default {
    name: 'other',
    components: {
        backButton,
        leaderboardCard,
        loadingSpinner,
    },
    data: () => ({
        page: 1,
        loading: true,
    }),
    computed: {
        ...mapGetters('leaderboards', [
            'getOtherLeaderboards',
            'getOtherLeaderboardsMetadata',
        ]),
        ...mapGetters('serverConfig', ['serverConfigByKey']),

        isFreemiumLeaderboardsEnabled() {
            return this.serverConfigByKey(ServerConfigurationProps.isFreemiumLeaderboardsEnabled);
        },

        noLeaderboardsOrNoFilterText() {
            if (!this.getOtherLeaderboards.length && !this.loading) {
                return this.$t('rewards.leaderboards.noLeaderboardsFound');
            }

            return '';
        },
    },
    async created() {
        await this.loadLeaderboards();
    },
    methods: {
        ...mapActions('leaderboards', ['fetchLeaderboards']),

        async loadLeaderboards(page = 1, partnerIds = []) {
            this.loading = true;

            await this.fetchLeaderboards({
                page,
                participating: 'false',
                partnerIds,
                types: ['global', 'partner'],
            });

            this.loading = false;
        },

        async loadMore() {
            if (this.loading) {
                return;
            }

            if (this.page < this.getOtherLeaderboardsMetadata.last_page) {
                await this.loadLeaderboards(++this.page);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.leaderboards {
    margin-top: 4rem;

    &__header {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: space-between;

        h1 {
            font-size: 2rem;
            margin: 0 0 1rem 0;
            justify-content: flex-start;

            @include min-width(md) {
                font-size: 2.5rem;
            }
        }
    }

    &__body {
        &-link {
            text-decoration: none;
        }

        .cards {
            margin-bottom: 3rem;
            transition: transform 0.1s ease-out;

            &:hover {
                cursor: pointer;
                opacity: 0.8;
                transform: scale(1.005);
            }
        }
    }

    &__no-leaderboards {
        text-align: center;
        font-size: 2rem;
    }

    &__load-more {
        width: 13rem;
        height: 4rem;
        margin: 0 auto;
        margin-bottom: 1rem;
    }
}
</style>